import type { TypedMyHotelLocalNavi } from './-MyHotelLocalNavi';
import RawMyHotelLocalNavi from './MyHotelLocalNavi.vue';
export * from './-MyHotelLocalNavi';
export const MyHotelLocalNavi = RawMyHotelLocalNavi as typeof TypedMyHotelLocalNavi;
